// extracted by mini-css-extract-plugin
module.exports = {"app__footer":"q_Z","app__footer__copyFoot":"q_0"};